'use client'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode, useState } from "react";

export default function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider data-component-id="src/lib/query-provider.tsx:9:4" data-component-path="src/lib/query-provider.tsx" data-component-line="9" data-component-file="query-provider.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
